/**
 * @override Safari iOS: do not force anonymous CORS during HTML5 metadata preload.
 */

import {Html as BaseHtml} from '@amblique/base/app/plugins/video/providers/html';

export class Html extends BaseHtml {
  async loadMetadata() {
    if (this.metadata) {
      return Promise.resolve(this.metadata);
    }

    if (this.metadataPromise) {
      return this.metadataPromise;
    }

    if (!this.isDestroyed()) {
      this.metadataPromise = new Promise((resolve, reject) => {
        const video = document.createElement('video');
        const crossorigin = this.options.params.crossorigin;

        video.preload = 'metadata';
        video.src = this.id;

        if (crossorigin) {
          video.crossOrigin = crossorigin;
        }

        const onLoadedMetadata = () => {
          const metadata = {
            type: 'video',
            version: '1.0',
            title: this.id.split('/').pop().split('.')[0],
            author_name: '',
            author_url: '',
            provider_name: 'HTML5 Video',
            provider_url: '',
            thumbnail_url: this.options.params.poster || '',
            html: '',
            width: video.videoWidth || 16,
            height: video.videoHeight || 9,
            duration: video.duration,
          };

          video.removeEventListener('loadedmetadata', onLoadedMetadata);
          video.removeEventListener('error', onError);
          video.src = '';

          resolve(this.onMetadataLoaded(metadata));
        };

        const onError = () => {
          video.removeEventListener('loadedmetadata', onLoadedMetadata);
          video.removeEventListener('error', onError);
          video.src = '';

          reject(new Error('Failed to load video metadata'));
        };

        video.addEventListener('loadedmetadata', onLoadedMetadata);
        video.addEventListener('error', onError);
      })
        .catch((error) => {
          this.handleError(error);
          throw error;
        })
        .finally(() => delete this.metadataPromise);

      return this.metadataPromise;
    }

    return Promise.resolve(this.metadata);
  }
}
